import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    margin: 'auto'
  },

  icon: {
    cursor: 'pointer'
  }
}))

export default useStyles
